export const TYPES = {
  FIRE_GTM_EVENT: 'FIRE_GTM_EVENT',
};

export const fireGTMEvent = (eventName, location, route) => ({
  type: TYPES.FIRE_GTM_EVENT,
  shortRef: location.query.shortref,
  bookType: route.bookType,
  eventName,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/tagActions.js
 **/